module.exports = __webpack_public_path__ + "static/img/ebook_index_five.aee84ef8.jpg";